import styled from 'styled-components';

export const ChatViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  height: 100%;
  width: 100%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    flex-direction: column-reverse;
  }
`;

const Column = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const UnpaddedColumn = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: calc(100% - 153px);
  }
`;

export const ChatColumn = styled(Column)`
  flex-grow: 2;
  overflow: hidden;
`;

export const ReportDetailColumn = styled(Column)`
  box-shadow: -6px 0px 10px 0px rgba(0, 0, 0, 0.035);
  padding: 0;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: initial;
  }
`;

export const ButtonWrapper = styled.div`
  padding-bottom: 10px;
`;

export const HeaderContainer = styled.div`
  padding: 20px 18px;
  display: flex;
  justify-content: space-between;
`;

export const ChatHeader = styled.div``;

export const ModalDescription = styled.section`
  margin: 0;
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  p:last-child {
    margin-bottom: 0;
  }
`;

export const ModalDescriptionBold = styled.span`
  ${(props) => props.theme.newTypography.textStyleBodySemibold};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;
